import React from "react";
import "./services.css";
import { BiCheck } from "react-icons/bi";

const Services = () => {
  return (
    <section id="services">
      <h5>Te ofrecemos</h5>
      <h2>Servicios</h2>
      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>Bodas de Destino</h3>
          </div>

          <ul className="service_list">
            <li>
              <BiCheck className="service_list-icon" />
              <p>
                Maquillaje para novias <br />y madrinas.
              </p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Cosmetología y peinado.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Manicure y Pedicure.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>
                Servicio en la comodidad <br />
                de tu hogar.
              </p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Zona de servicio.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>
                Presupuesto con 10 <br />
                dias de anticipación.
              </p>
            </li>
          </ul>
        </article>
        {/* End of UX/UI Design */}
        <article className="service">
          <div className="service__head">
            <h3>MakeUp Social.</h3>
          </div>

          <ul className="service_list">
            <li>
              <BiCheck className="service_list-icon" />
              <p>Tensum Flash Effect.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Matt primer.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Lip Primer.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Correctores en crema.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Polvo fijador.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Polvo traslúcido.</p>
            </li>
          </ul>
        </article>
        {/* End of Web Development */}
        <article className="service">
          <div className="service__head">
            <h3>Producciones de fotos.</h3>
          </div>

          <ul className="service_list">
            <li>
              <BiCheck className="service_list-icon" />
              <p>Paleta de sombras.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Eyeliner Long-Lasting.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Eyebrown Design.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Colorete Blend-Blush.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Labios perfectos.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Pestañas.</p>
            </li>
          </ul>
        </article>
        {/* Content Creation */}
      </div>
    </section>
  );
};

export default Services;

// 1. BODAS DE DESTINO.
// 2. MAKE UP SOCIAL.
// 3. PRODUCCIONES DE FOTOS.
